import { useAppDispatch, useAppSelector } from '@/src/store/hooks'
import {
    fetchVisaBookingList,
    getVisaBookingListState
} from '@/src/store/slices/visaSlice/visaBookingListSlice'
import { logError } from '@/src/utils/logError'
import { useEffect, useMemo } from 'react'

const useBookingList = () => {
    const dispatch = useAppDispatch()
    const { visaBookingList, isLoading } = useAppSelector(
        getVisaBookingListState
    )
    useEffect(() => {
        if (isLoading) {
            dispatch(fetchVisaBookingList())
        }
    }, [])

    const visaList = useMemo(() => {
        try {
            if (Array.isArray(visaBookingList)) {
                return visaBookingList.map((booking, index) => {
                    return {
                        item: booking,
                        key: `${index}`
                    }
                })
            }
            return []
        } catch (error) {
            logError('getVisaBookingList', error)
            return []
        }
    }, [visaBookingList])

    return {
        isLoading,
        visaList
    }
}

export default useBookingList
